export const LOCAL_STORAGE_KEYS = {
  inputSource: {
    mode: 'inputsource-mode',
    applicationNumber: 'inputsource-application-number',
    xmlContent: 'inputsource-xml',
    xmlFilename: 'inputsource-xml-filename'
  },
  scoreModelStorageKey: 'scoreModel-id'
};
